import React, { ReactElement, useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useLocation } from 'react-use';
import qs from 'query-string';
import ErrorPage_503 from './Error_503';
import ErrorPage_403 from './Error_403';
import ErrorPage_500 from './Error_500';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 10000,
    backgroundColor: 'white'
  },
  border: {
    padding: theme.spacing(6.25),
    background: '#597CA5',
    height: '100%',
    width: '100%',
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(4.25)
    },
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(2.25)
    }
  },
  error: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: 'white'
  }
}));

const ErrorPage = (): ReactElement => {
  const classes = useStyles();
  const location = useLocation();

  const { code, ecid } = qs.parse(location.search || '') as {
    code: string;
    ecid: string;
  };

  const errorContent = useMemo(() => {
    if (code === '503') {
      return <ErrorPage_503 ecid={ecid} />;
    }
    if (code === '403') {
      return <ErrorPage_403 />;
    }

    return <ErrorPage_500 ecid={ecid} />;
  }, [code, ecid]);

  return (
    <div data-testid="error-page-root" className={classes.root}>
      <div className={classes.border}>
        <div className={classes.error}>{errorContent}</div>
      </div>
    </div>
  );
};

export default ErrorPage;
